// Replace "@/components/ui/card"
export function Card({ children, className }) {
  return (
    <div className={`bg-white rounded-2xl shadow p-4 ${className}`}>
      {children}
    </div>
  );
}
export function CardHeader({ children }) {
  return <div className="mb-2">{children}</div>;
}
export function CardTitle({ children }) {
  return <h2 className="text-lg font-semibold">{children}</h2>;
}
export function CardContent({ children }) {
  return <div>{children}</div>;
}

// Replace "@/components/ui/button"
export function Button({ children, variant = "default", className, ...props }) {
  const base = "rounded-xl px-4 py-2 font-semibold";
  const styles =
    variant === "outline"
      ? "border border-gray-300 text-gray-700 bg-white hover:bg-gray-100"
      : "bg-blue-600 text-white hover:bg-blue-700";
  return (
    <button className={`${base} ${styles} ${className}`} {...props}>
      {children}
    </button>
  );
}
